










import Vue from 'vue'
import { IconInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Icon',
  props: {
    templateItemData: {
      type: Object as () => IconInterface,
      required: true
    }
  }
})
